import { render, staticRenderFns } from "./SetGradingCriteria.vue?vue&type=template&id=aecc87e0&scoped=true&"
import script from "./SetGradingCriteria.vue?vue&type=script&lang=js&"
export * from "./SetGradingCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecc87e0",
  null
  
)

export default component.exports